/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPINTERESTWITHHOLDINGTAXREASON = {
    DoubleTaxAgreementInterestReasonH: 'H',
    ForeignMemberPhysicallyPresentInTheRepublic183DaysAYearInterestReasonF: 'F'
} as const;
export type IAPINTERESTWITHHOLDINGTAXREASON = typeof IAPINTERESTWITHHOLDINGTAXREASON[keyof typeof IAPINTERESTWITHHOLDINGTAXREASON];


export function IAPINTERESTWITHHOLDINGTAXREASONFromJSON(json: any): IAPINTERESTWITHHOLDINGTAXREASON {
    return IAPINTERESTWITHHOLDINGTAXREASONFromJSONTyped(json, false);
}

export function IAPINTERESTWITHHOLDINGTAXREASONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPINTERESTWITHHOLDINGTAXREASON {
    return json as IAPINTERESTWITHHOLDINGTAXREASON;
}

export function IAPINTERESTWITHHOLDINGTAXREASONToJSON(value?: IAPINTERESTWITHHOLDINGTAXREASON | null): any {
    return value as any;
}

